import { handleErrors } from "../util/api-utils";

/**
 * Fetches alerts for a specific user.
 * @param {function} successCallback The success callback function.
 */
export function getAgencyAlerts(successCallback) {
    fetch("api/Alerts/RetrieveAgencyAlerts", {
        method: "get",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
    })
        .then(handleErrors)
        .then(successCallback)
        .catch(console.error);
}

/**
 * Marks an alert as complete.
 * @param {any} request request containing the ID of the alert to mark as complete and date.
 * @param {function} successCallback The success callback function.
 */
export function updateAlert(request, successCallback) {
    fetch(`api/Alerts/UpdateAgencyAlert`, {
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(request)
    })
        .then(handleErrors)
        .then(successCallback)
        .catch(console.error);
}
